module.exports = __webpack_public_path__ + "media/images/icon-bw-line@3x-050309c4fcd6405e9fbbebd6a0789f6a.png";